import { PricingValueKind } from "services/api/pricing/types";

/**
 * Jedinica koja stoji u polju, uz sam broj.
 *
 * Novac je prazan jer je cijeli cjenik u eurima, pa bi znak valute uz svaki iznos bio šum.
 */
export const VALUE_KIND_UNIT: Record<PricingValueKind, string> = {
  Money: "€",
  Percent: "%",
  Days: "dana",
  Count: "",
};
